import { FormControl, InputLabel, MenuItem, Portal, Select, Stack, Typography } from "@mui/material";
import { useEffect, useState } from "react";

import {
  getTestBrandOverride,
  isTestBrandOverrideEnabled,
  setTestBrandOverride,
  testBrandOverrideChangedEvent,
} from "utils/brandingUtils";
import { InternalAppType } from "types/branding";

/** Visible only in local/preview builds; never rendered in production. */
export default function TestBrandSwitcher() {
  const [brand, setBrand] = useState<InternalAppType | "">(getTestBrandOverride() || "");

  useEffect(() => {
    const refresh = () => setBrand(getTestBrandOverride() || "");
    window.addEventListener(testBrandOverrideChangedEvent, refresh);
    return () => window.removeEventListener(testBrandOverrideChangedEvent, refresh);
  }, []);

  if (!isTestBrandOverrideEnabled()) return null;

  return (
    <Portal>
      <Stack
        direction="row"
        alignItems="center"
        spacing={1}
        sx={{
          position: "fixed",
          left: 16,
          bottom: 16,
          // Map layouts and Leaflet controls create several stacking contexts. Keep this
          // developer-only control above them; its menu is explicitly one level higher.
          zIndex: 100000,
          px: 1.25,
          py: 0.75,
          borderRadius: 1,
          bgcolor: "rgba(22, 66, 36, 0.96)",
          color: "common.white",
          boxShadow: 3,
        }}
      >
        <Typography variant="caption" sx={{ fontWeight: 700 }}>
          Test brand
        </Typography>
        <FormControl size="small" sx={{ minWidth: 142, bgcolor: "common.white", borderRadius: 1 }}>
          <InputLabel id="test-brand-switcher-label">Brand</InputLabel>
          <Select
            labelId="test-brand-switcher-label"
            label="Brand"
            value={brand}
            MenuProps={{ sx: { zIndex: 100001 } }}
            onChange={(event) => {
              setTestBrandOverride((event.target.value as InternalAppType) || null);
              // Several legacy consumers resolve branding during initialisation. A reload makes
              // the selected test brand deterministic across the whole app, not just this control.
              window.location.reload();
            }}
          >
            <MenuItem value="">Automatic</MenuItem>
            <MenuItem value="forsler">Forsler</MenuItem>
            <MenuItem value="skovkortet">Skovkortet</MenuItem>
            <MenuItem value="george">George</MenuItem>
          </Select>
        </FormControl>
      </Stack>
    </Portal>
  );
}
